module.exports = __webpack_public_path__ + "img/509fb1c4b4b014240464744b5f3b30b7.509fb1c4.png";